module.exports = __webpack_public_path__ + "img/img53.d8266c5f.png";